import { render, staticRenderFns } from "./culture-chunk.vue?vue&type=template&id=745acf27&scoped=true&"
var script = {}
import style0 from "./culture-chunk.vue?vue&type=style&index=0&id=745acf27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745acf27",
  null
  
)

export default component.exports